export const numberToCurrency = (number, includeCurrency) => {
    const formattedNumber = includeCurrency ? formatter.format(number) 
    : formatterWidoutCurrency.format(number)

    return formattedNumber;
};

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const formatterWidoutCurrency = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});